<template>
  <div class="container">
    <div class="logo">
      <div class="logo-text">锡慧停</div>
    </div>
    <div class="title">锡慧停</div>
    <div class="subtitle">智慧停车，便捷出行</div>
    <div class="tab-bar">
      <div :class="['tab', activeTab==='captcha' && 'active']" @click="activeTab='captcha'">验证码登录</div>
      <div :class="['tab', activeTab==='password' && 'active']" @click="activeTab='password'">密码登录</div>
    </div>

    <form v-show="activeTab==='captcha'" class="form" @submit.prevent="handleCaptchaLogin">
      <div class="input-group">
        <span class="input-prefix">+86</span>
        <input class="input" v-model.trim="phone" type="tel" maxlength="11" placeholder="请输入手机号码" required>
      </div>
      <div class="input-group">
        <input class="input" v-model.trim="captcha" maxlength="4" placeholder="请输入验证码" required>
        <button type="button" class="get-captcha-btn" @click="getCaptcha">获取验证码</button>
      </div>
      <div class="row">
        <label style="display:flex;align-items:center;">
          <input type="checkbox" class="checkbox" v-model="remember">
          <span class="remember-label">记住登录状态</span>
        </label>
        <span class="forget" @click="forget">忘记密码？</span>
        <span class="contact-service" @click="contactService">联系客服</span>
      </div>
      <button class="login-btn" type="submit">立即登录</button>
      <button class="wechat-login-btn" type="button" @click="handleWechatLogin">
        <span class="wechat-icon">📱</span>
        微信快捷登录
      </button>
    </form>

    <form v-show="activeTab==='password'" class="form" @submit.prevent="handlePasswordLogin">
      <div class="input-group">
        <input class="input" v-model.trim="username" maxlength="20" placeholder="账号" required>
      </div>
      <div class="input-group">
        <input class="input" v-model.trim="password" maxlength="20" placeholder="密码" :type="showPassword ? 'text' : 'password'" required>
        <button type="button" class="password-toggle-btn" @click="togglePasswordVisibility">
          <span class="eye-icon">{{ showPassword ? '👁️' : '👁️‍🗨️' }}</span>
        </button>
      </div>
      <div class="row" style="justify-content:flex-end;">
        <span class="forget" @click="forget">忘记密码？</span>
        <span class="contact-service" @click="contactService">联系客服</span>
      </div>
      <button class="login-btn" type="submit">立即登录</button>
    </form>
  </div>
</template>

<script>
import { loginByPassword, loginByWxBusiness } from '@/api/login'
import { mapActions } from 'vuex'
import wechatAuth from '@/utils/wechatAuth'
import { getWxOpenIdByCode, bindWxOpenId } from '@/api/user'
import { isLoginValid } from '@/utils/user'
import { getBusinessByUser } from '@/api/business'

export default {
  name: 'LoginPage',
  data () {
    return {
      activeTab: 'password',
      phone: '',
      captcha: '',
      remember: true,
      username: '',
      password: '',
      loading: false,
      showPassword: false,
      wxOpenId: null  // 存储静默获取的微信openid
    }
  },
  async mounted() {
    // 检查是否有有效的登录凭证（2天内）
    console.log('============== 登录页面 mounted 开始 ==============')
    console.log('📝 步骤1: 检查登录凭证是否有效（2天内）')
    
    if (isLoginValid()) {
      // 有有效的登录凭证，自动登录
      console.log('✅ 检测到有效的登录凭证，自动登录')
      const token = localStorage.getItem('token')
      if (token) {
        // 恢复token到store（SET_TOKEN会自动保存过期时间，实现自动续期）
        this.$store.commit('SET_TOKEN', token)
        
        // 获取用户信息
        try {
          await this.ForceRefreshUserInfo()
          
          // 检查商户状态
          try {
            const userId = this.$store.getters.userInfo?.userId || localStorage.getItem('userId')
            if (userId) {
              console.log('============== [自动登录] 检查商户状态 ==============')
              console.log('📝 [自动登录] 用户ID:', userId)
              
              // 获取商户信息
              const businessResp = await getBusinessByUser(userId)
              const business = businessResp?.data || businessResp
              
              console.log('📝 [自动登录] 商户信息:', business)
              
              // 检查商户是否被停用
              if (business && (business.isDisabled === true || business.is_disabled === true)) {
                console.error('❌ [自动登录] 商户已被停用，阻止自动登录')
                
                // 清除token和用户信息
                this.$store.commit('CLEAR_USER')
                this.$store.commit('SET_TOKEN', '')
                localStorage.removeItem('token')
                localStorage.removeItem('userInfo')
                localStorage.removeItem('userId')
                sessionStorage.removeItem('wx_open_id')
                
                // 提示用户
                alert('您的账号对应的商户已被停用，无法登录。请联系管理员。')
                this.clearUserCache()
                return // 阻止自动登录和页面跳转
              }
              
              console.log('✅ [自动登录] 商户状态正常，继续自动登录流程')
              console.log('============== [自动登录] 商户状态检查完成 ==============')
            }
          } catch (e) {
            console.warn('⚠️ [自动登录] 检查商户状态失败（不影响自动登录）:', e)
            // 如果检查失败，为了安全起见，可以选择阻止登录或继续
            // 这里选择继续，因为可能是网络问题等临时错误
          }
          
          console.log('✅ 自动登录成功，跳转到首页')
          // 跳转到首页
          this.$router.replace('/home')
          return
        } catch (error) {
          console.error('❌ 自动登录获取用户信息失败:', error)
          // 获取用户信息失败，清除凭证，继续登录流程
          this.clearUserCache()
        }
      }
    } else {
      // 没有有效的登录凭证，清空用户缓存
      console.log('ℹ️ 未找到有效的登录凭证，清空用户缓存')
      this.clearUserCache()
    }
    
    // 处理微信授权回调（无论是否在微信浏览器中，因为可能是从微信跳转过来的）
    // URL格式: https://testbusiness.xihuiting.com/?code=xxx&state=XHT_PUBLIC#/login
    console.log('📍 当前完整URL:', window.location.href)
    console.log('📍 window.location.search:', window.location.search)
    console.log('📍 window.location.hash:', window.location.hash)
    
    const code = wechatAuth.getCodeFromUrl()
    const state = wechatAuth.getStateFromUrl()
    
    console.log('🔍 登录页面初始化，检查微信授权回调:', {
      'code': code ? `存在(${code.substring(0, 10)}...)` : '不存在',
      'state': state || '无',
      '当前URL': window.location.href
    })
    
    if (code) {
      console.log('✅ ========== 检测到微信授权回调，开始处理 ==========')
      console.log('📝 步骤1: 调用商家微信登录接口 loginByWxBusiness()')
      // 有code，调用商家微信登录接口
      this.handleWxBusinessLogin(code).then(async (result) => {
        if (result && result.isBound) {
          // 已绑定，直接登录成功
          console.log('✅ 商家微信登录成功（已关联账号），直接进入主页面')
          const token = result.token
          this.$store.commit('SET_TOKEN', token)
          // 如果有wxOpenId，保存到localStorage
          if (result.wxOpenId) {
            localStorage.setItem('wx_open_id', result.wxOpenId)
            console.log('📝 保存wxOpenId到localStorage:', result.wxOpenId)
          }
          
          // 检查商户状态
          try {
            // 先获取用户信息
            await this.ForceRefreshUserInfo()
            const userId = this.$store.getters.userInfo?.userId || localStorage.getItem('userId')
            
            if (userId) {
              console.log('============== [微信登录] 检查商户状态 ==============')
              console.log('📝 [微信登录] 用户ID:', userId)
              
              // 获取商户信息
              const businessResp = await getBusinessByUser(userId)
              const business = businessResp?.data || businessResp
              
              console.log('📝 [微信登录] 商户信息:', business)
              
              // 检查商户是否被停用
              if (business && (business.isDisabled === true || business.is_disabled === true)) {
                console.error('❌ [微信登录] 商户已被停用，阻止登录')
                
                // 清除token和用户信息
                this.$store.commit('CLEAR_USER')
                this.$store.commit('SET_TOKEN', '')
                localStorage.removeItem('token')
                localStorage.removeItem('userInfo')
                localStorage.removeItem('userId')
                localStorage.removeItem('wx_open_id')
                sessionStorage.removeItem('wx_open_id')
                
                // 提示用户并阻止登录
                alert('您的账号对应的商户已被停用，无法登录。请联系管理员。')
                return // 阻止后续流程和页面跳转
              }
              
              console.log('✅ [微信登录] 商户状态正常，继续登录流程')
              console.log('============== [微信登录] 商户状态检查完成 ==============')
            }
          } catch (e) {
            console.warn('⚠️ [微信登录] 检查商户状态失败（不影响登录）:', e)
            // 如果检查失败，为了安全起见，可以选择阻止登录或继续
            // 这里选择继续，因为可能是网络问题等临时错误
          }
          
          // 跳转到首页
          setTimeout(() => {
            this.$router.replace('/home')
          }, 500)
        } else if (result && result.wxOpenId) {
          // 未绑定，保存openId，等待用户输入账号密码登录
          console.log('ℹ️ ========== 商家微信登录：未关联账号，返回openId ==========')
          console.log('📝 步骤2: 保存wxOpenId到sessionStorage:', result.wxOpenId)
          this.wxOpenId = result.wxOpenId
          sessionStorage.setItem('wx_open_id', result.wxOpenId)
          console.log('📝 步骤3: 等待用户输入账号密码登录并绑定')
        } else {
          console.warn('⚠️ 商家微信登录返回异常:', result)
        }
        console.log('============== 微信授权回调处理完成 ==============')
      }).catch((error) => {
        console.error('❌ 处理商家微信登录异常:', error)
        console.error('错误堆栈:', error.stack)
        // 如果商家微信登录失败，降级到原来的方式（获取openId）
        console.log('📝 降级处理: 使用原来的方式获取openId')
        this.silentGetWxOpenId().catch((e) => {
          console.error('❌ 降级处理也失败:', e)
        })
      })
    } else {
      // 没有code，检查是否已有保存的openid
      console.log('ℹ️ ========== 没有微信授权回调，检查已保存的openid ==========')
      const savedOpenId = sessionStorage.getItem('wx_open_id')
      console.log('📝 检查sessionStorage中的wx_open_id:', savedOpenId || '不存在')
      if (savedOpenId) {
        this.wxOpenId = savedOpenId
        console.log('✅ 使用已保存的微信openid:', savedOpenId)
      } else {
        console.log('ℹ️ 没有微信授权回调，也没有保存的openid')
      }
    }
    console.log('============== 登录页面 mounted 结束 ==============')
  },
  methods: {
    ...mapActions(['GetInfo', 'Logout', 'ForceRefreshUserInfo']),
    getCaptcha () {
      // 调用后端接口获取验证码
      // TODO: 实现真实的验证码获取接口
      alert('暂时无法获取验证码')
    },
    forget () { alert('请联系管理员重置密码') },
    contactService () { alert('请联系客服：400-900-9290') },
    handleWechatLogin () { alert('微信登录功能开发中...') },
    togglePasswordVisibility () {
      this.showPassword = !this.showPassword
    },
    /**
     * 处理商家微信登录（使用新的登录接口）
     * @param {string} code 微信授权code
     * @returns {Promise<{isBound: boolean, token?: string, wxOpenId?: string}>}
     */
    async handleWxBusinessLogin(code) {
      try {
        console.log('============== [handleWxBusinessLogin] 开始商家微信登录 ==============')
        console.log('📝 [handleWxBusinessLogin] 调用商家微信登录接口，code:', code?.substring(0, 10) + '...')
        
        const response = await loginByWxBusiness(code)
        console.log('✅ [handleWxBusinessLogin] 商家微信登录接口响应成功')
        console.log('📝 [handleWxBusinessLogin] 响应数据:', response)
        
        const data = response?.data || response
        console.log('📝 [handleWxBusinessLogin] 解析后的数据:', data)
        console.log('📝 [handleWxBusinessLogin] isBound:', data?.isBound)
        console.log('📝 [handleWxBusinessLogin] token:', data?.token ? '存在' : '不存在')
        console.log('📝 [handleWxBusinessLogin] wxOpenId:', data?.wxOpenId || '不存在')
        
        if (data?.isBound && data?.token) {
          console.log('✅ [handleWxBusinessLogin] wx_open_id已关联商家账号，返回token')
          return { isBound: true, token: data.token }
        } else if (data?.wxOpenId) {
          console.log('ℹ️ [handleWxBusinessLogin] wx_open_id未关联商家账号，返回openId')
          return { isBound: false, wxOpenId: data.wxOpenId }
        } else {
          console.warn('⚠️ [handleWxBusinessLogin] 响应数据格式异常:', data)
          return null
        }
      } catch (error) {
        console.error('❌ [handleWxBusinessLogin] 商家微信登录失败:', error)
        console.error('  - 错误消息:', error.message)
        console.error('  - 错误响应:', error.response)
        throw error
      }
    },
    /**
     * 静默获取微信openid（从URL中的code获取，备用方案）
     */
    async silentGetWxOpenId() {
      try {
        console.log('============== [silentGetWxOpenId] 开始静默获取微信openid ==============')
        console.log('📍 [silentGetWxOpenId] 当前URL:', window.location.href)
        console.log('📍 [silentGetWxOpenId] window.location.search:', window.location.search)
        
        // 1. 检查URL中是否有code（授权回调）
        console.log('📝 [silentGetWxOpenId] 步骤1: 调用 wechatAuth.handleAuthCallback()')
        const authResult = await wechatAuth.handleAuthCallback()
        console.log('📝 [silentGetWxOpenId] 步骤1结果:', authResult ? `成功(code: ${authResult.code?.substring(0, 10)}..., state: ${authResult.state})` : '失败')
        
        if (authResult && authResult.code) {
          console.log('🔄 [silentGetWxOpenId] 检测到微信授权回调')
          console.log('  - code:', authResult.code)
          console.log('  - state:', authResult.state)
          
          // 2. 根据state确定账号类型
          // state可能是: XHT_PUBLIC, HZ, DEFAULT 或随机字符串
          // 如果是业务标识，使用对应的账号类型；否则默认使用 XHT_PUBLIC（xht-web-business对应XHT-TEST）
          console.log('📝 [silentGetWxOpenId] 步骤2: 根据state确定账号类型')
          let accountType = 'XHT_PUBLIC' // 默认值（xht-web-business使用XHT-TEST账号）
          if (authResult.state) {
            const stateUpper = authResult.state.toUpperCase()
            if (stateUpper === 'XHT_PUBLIC' || stateUpper === 'XHT_TEST') {
              accountType = 'XHT_PUBLIC'
              console.log('📌 [silentGetWxOpenId] state是XHT_PUBLIC/XHT_TEST，使用XHT_PUBLIC账号类型（对应XHT-TEST的appId）')
            } else if (stateUpper === 'HZ') {
              accountType = 'HZ'
              console.log('📌 [silentGetWxOpenId] state是HZ，使用HZ账号类型')
            } else if (stateUpper === 'DEFAULT') {
              accountType = 'DEFAULT'
              console.log('📌 [silentGetWxOpenId] state是DEFAULT，使用DEFAULT账号类型')
            } else {
              console.log('📌 [silentGetWxOpenId] state是随机字符串，使用默认值XHT_PUBLIC')
            }
          } else {
            console.log('📌 [silentGetWxOpenId] state为空，使用默认值XHT_PUBLIC')
          }
          console.log('📌 [silentGetWxOpenId] 最终使用的账号类型:', accountType, '(state:', authResult.state, ')')
          console.log('📌 [silentGetWxOpenId] 将使用XHT-TEST对应的appId和appSecret获取openid')
          
          // 3. 通过code获取openid
          console.log('📝 [silentGetWxOpenId] 步骤3: 调用后端API获取openid')
          console.log('  - API: getWxOpenIdByCode')
          console.log('  - code:', authResult.code)
          console.log('  - accountType:', accountType)
          try {
            const response = await getWxOpenIdByCode(authResult.code, accountType)
            console.log('📝 [silentGetWxOpenId] 步骤3结果: API调用成功')
            console.log('  - 响应结构:', {
              'hasData': !!response?.data,
              'hasResponse': !!response,
              'responseType': typeof response
            })
            
            const openid = response?.data || response
            console.log('📝 [silentGetWxOpenId] 步骤3.1: 提取openid:', openid ? `成功(${openid})` : '失败')
            
            if (openid) {
              this.wxOpenId = openid
              console.log('✅ [silentGetWxOpenId] 静默获取微信openid成功:', openid)
              
              // 保存到sessionStorage，供登录成功后使用
              console.log('📝 [silentGetWxOpenId] 步骤4: 保存openid到sessionStorage')
              sessionStorage.setItem('wx_open_id', openid)
              
              // 验证存储是否成功
              const verifySaved = sessionStorage.getItem('wx_open_id')
              console.log('📝 [silentGetWxOpenId] 步骤4.1: 验证存储结果:', verifySaved === openid ? '✅ 存储成功' : '❌ 存储失败')
              console.log('  - 存储的openid:', verifySaved)
              console.log('  - 原始openid:', openid)
              
              console.log('============== [silentGetWxOpenId] 获取并存储openid完成 ==============')
              return openid
            } else {
              console.warn('⚠️ [silentGetWxOpenId] 获取openid失败，响应:', response)
              return null
            }
          } catch (error) {
            console.error('❌ [silentGetWxOpenId] 通过code获取openid失败:', error)
            console.error('  - 错误消息:', error.message)
            console.error('  - 错误堆栈:', error.stack)
            return null
          }
        } else {
          // 4. 如果没有code，检查是否已有openid
          console.log('📝 [silentGetWxOpenId] 步骤4: 没有code，检查已保存的openid')
          const savedOpenId = sessionStorage.getItem('wx_open_id')
          console.log('📝 [silentGetWxOpenId] 步骤4.1: sessionStorage中的wx_open_id:', savedOpenId || '不存在')
          if (savedOpenId) {
            this.wxOpenId = savedOpenId
            console.log('✅ [silentGetWxOpenId] 使用已保存的微信openid:', savedOpenId)
            return savedOpenId
          } else {
            console.log('ℹ️ [silentGetWxOpenId] 未获取到openid，等待用户登录后再处理')
            return null
          }
        }
      } catch (error) {
        console.error('❌ [silentGetWxOpenId] 静默获取微信openid异常:', error)
        console.error('  - 错误消息:', error.message)
        console.error('  - 错误堆栈:', error.stack)
        // 静默获取失败不影响登录流程，继续执行
        return null
      }
    },
    /**
     * 绑定微信openid到管理员账号
     */
    async bindWxOpenIdToUser() {
      console.log('============== [bindWxOpenIdToUser] 开始绑定微信openid到管理员账号 ==============')
      console.log('📝 [bindWxOpenIdToUser] 步骤1: 检查this.wxOpenId:', this.wxOpenId || '不存在')
      
      if (!this.wxOpenId) {
        // 尝试从sessionStorage获取
        console.log('📝 [bindWxOpenIdToUser] 步骤1.1: this.wxOpenId为空，从sessionStorage获取')
        this.wxOpenId = sessionStorage.getItem('wx_open_id')
        console.log('📝 [bindWxOpenIdToUser] 步骤1.2: 从sessionStorage获取结果:', this.wxOpenId || '不存在')
      }
      
      if (!this.wxOpenId) {
        console.log('⚠️ [bindWxOpenIdToUser] 没有微信openid，跳过绑定')
        console.log('  - this.wxOpenId:', this.wxOpenId)
        console.log('  - sessionStorage中的wx_open_id:', sessionStorage.getItem('wx_open_id'))
        return false
      }
      
      try {
        console.log('📝 [bindWxOpenIdToUser] 步骤2: 准备调用绑定API')
        console.log('  - wxOpenId:', this.wxOpenId)
        console.log('  - API: bindWxOpenId')
        
        const response = await bindWxOpenId(this.wxOpenId)
        console.log('✅ [bindWxOpenIdToUser] 绑定微信openid成功')
        console.log('  - 响应:', response)
        
        // 清除sessionStorage中的openid
        console.log('📝 [bindWxOpenIdToUser] 步骤3: 清除sessionStorage中的openid')
        sessionStorage.removeItem('wx_open_id')
        
        // 验证清除是否成功
        const verifyCleared = sessionStorage.getItem('wx_open_id')
        console.log('📝 [bindWxOpenIdToUser] 步骤3.1: 验证清除结果:', verifyCleared ? '❌ 清除失败' : '✅ 清除成功')
        
        console.log('============== [bindWxOpenIdToUser] 绑定完成 ==============')
        return true
      } catch (error) {
        console.error('❌ [bindWxOpenIdToUser] 绑定微信openid失败:', error)
        console.error('  - 错误消息:', error.message)
        console.error('  - 错误堆栈:', error.stack)
        // 绑定失败不影响登录流程，只记录日志
        return false
      }
    },
    // 清空用户缓存
    clearUserCache() {
      console.log('=== 进入登录页面，清空用户缓存 ===')
      
      // 清空localStorage中的用户信息
      localStorage.removeItem('userInfo')
      console.log('已清除localStorage中的userInfo')
      
      // 清空Vuex中的用户状态
      this.$store.commit('CLEAR_USER')
      console.log('已清除Vuex中的用户状态')
      
      console.log('用户缓存清空完成')
      console.log('========================')
    },
    handleCaptchaLogin () {
      if (!/^\d{11}$/.test(this.phone)) return alert('请输入11位手机号')
      if (!this.captcha) return alert('请输入验证码')
      // TODO: 调用后端接口验证验证码
      // 暂时允许通过，实际应该调用后端验证
      this.$router.replace('/home')
    },
    async handlePasswordLogin () {
      if (!this.username || !this.password) return alert('请输入账号和密码')
      this.loading = true
      try {
        // 检查是否有保存的wxOpenId，如果有则一起传入进行绑定
        const wxOpenId = this.wxOpenId || sessionStorage.getItem('wx_open_id')
        const loginPayload = { 
          username: this.username, 
          password: this.password 
        }
        if (wxOpenId) {
          loginPayload.wxOpenId = wxOpenId
          console.log('📝 [handlePasswordLogin] 检测到wxOpenId，将在登录后自动绑定:', wxOpenId)
        }
        
        console.log('============== [handlePasswordLogin] 开始账号密码登录 ==============')
        console.log('📝 [handlePasswordLogin] 登录参数:', { 
          username: this.username, 
          hasPassword: !!this.password,
          hasWxOpenId: !!wxOpenId
        })
        
        const resp = await loginByPassword(loginPayload)
        // 兼容多种返回结构：
        // 1) { code, message, data: { token } }
        // 2) { token }
        // 3) 纯字符串 token
        const token = (
          resp?.data?.token ||
          resp?.data?.accessToken ||
          resp?.token ||
          (typeof resp === 'string' ? resp : undefined)
        )
        if (!token) throw new Error('未获取到token')
        
        // 使用Vuex设置token
        this.$store.commit('SET_TOKEN', token)

        // 先从 token 中尝试解析 userId 并缓存，确保后续页面可用
        try {
          const parts = (token || '').split('.')
          if (parts.length === 3) {
            const payload = JSON.parse(atob(parts[1]))
            const tid = payload && (payload.userId || payload.uid || payload.sub)
            if (tid) localStorage.setItem('userId', String(tid))
          }
        } catch (e) { /* ignore token parse error */ }
        
        // 尝试获取用户信息（强制刷新，忽略缓存）
        try {
          await this.ForceRefreshUserInfo()
          // 记录 userId，供页面切换时快速读取
          try {
            const ui = this.$store.getters.userInfo || {}
            if (ui && ui.userId) {
              localStorage.setItem('userId', String(ui.userId))
            }
          } catch (e) { /* ignore */ }
          
          // 登录成功后，检查商户状态
          try {
            const userId = this.$store.getters.userInfo?.userId || localStorage.getItem('userId')
            if (userId) {
              console.log('============== [handlePasswordLogin] 检查商户状态 ==============')
              console.log('📝 [handlePasswordLogin] 用户ID:', userId)
              
              // 获取商户信息
              const businessResp = await getBusinessByUser(userId)
              const business = businessResp?.data || businessResp
              
              console.log('📝 [handlePasswordLogin] 商户信息:', business)
              
              // 检查商户是否被停用
              if (business && (business.isDisabled === true || business.is_disabled === true)) {
                console.error('❌ [handlePasswordLogin] 商户已被停用，阻止登录')
                
                // 清除token和用户信息
                this.$store.commit('CLEAR_USER')
                this.$store.commit('SET_TOKEN', '')
                localStorage.removeItem('token')
                localStorage.removeItem('userInfo')
                localStorage.removeItem('userId')
                sessionStorage.removeItem('wx_open_id')
                
                // 提示用户并阻止登录
                alert('您的账号对应的商户已被停用，无法登录。请联系管理员。')
                this.loading = false
                return // 阻止后续流程和页面跳转
              }
              
              console.log('✅ [handlePasswordLogin] 商户状态正常，继续登录流程')
              console.log('============== [handlePasswordLogin] 商户状态检查完成 ==============')
            }
          } catch (e) {
            console.warn('⚠️ [handlePasswordLogin] 检查商户状态失败（不影响登录）:', e)
            // 如果检查失败，为了安全起见，可以选择阻止登录或继续
            // 这里选择继续，因为可能是网络问题等临时错误
          }
          
          // 登录成功后，立即获取商户信息并缓存
          try {
            await this.$store.dispatch('FetchMerchantBalance')
            console.log('登录后已获取商户信息并缓存')
          } catch (e) {
            console.warn('登录后获取商户信息失败（不影响登录）:', e)
          }
          
          // 打印登录成功后的用户信息
          console.log('=== 登录成功，用户信息已获取 ===')
          console.log('当前用户信息:', this.$store.getters.userInfo)
          console.log('用户昵称:', this.$store.getters.nickname)
          console.log('用户真实姓名:', this.$store.getters.realName)
          console.log('用户余额:', this.$store.getters.balance)
          console.log('================================')
          
          // 登录成功后，检查是否已通过登录接口绑定wxOpenId
          console.log('============== [handlePasswordLogin] 登录成功，检查wxOpenId绑定状态 ==============')
          const savedWxOpenId = sessionStorage.getItem('wx_open_id')
          console.log('📝 [handlePasswordLogin] sessionStorage中的wx_open_id:', savedWxOpenId || '不存在')
          
          // 如果登录请求中已传入wxOpenId，后端会自动绑定，保存到localStorage并清除sessionStorage
          if (wxOpenId) {
            console.log('✅ [handlePasswordLogin] 登录时已传入wxOpenId，后端已自动绑定')
            // 保存wxOpenId到localStorage（与token一起持久化）
            localStorage.setItem('wx_open_id', wxOpenId)
            console.log('📝 [handlePasswordLogin] 保存wxOpenId到localStorage:', wxOpenId)
            // 清除sessionStorage中的临时openId
            console.log('📝 [handlePasswordLogin] 清除sessionStorage中的wx_open_id')
            sessionStorage.removeItem('wx_open_id')
            this.wxOpenId = null
          } else if (savedWxOpenId) {
            // 如果登录时没有传入wxOpenId，但sessionStorage中有，尝试绑定
            console.log('📝 [handlePasswordLogin] 登录时未传入wxOpenId，但sessionStorage中有，尝试绑定')
            try {
              await this.bindWxOpenIdToUser()
            } catch (e) {
              console.warn('⚠️ [handlePasswordLogin] 绑定微信openid失败（不影响登录）:', e)
            }
          } else {
            console.log('ℹ️ [handlePasswordLogin] 没有wx_open_id，跳过绑定')
          }
          console.log('============== [handlePasswordLogin] 绑定流程完成 ==============')
        } catch (error) {
          console.error('获取用户信息失败:', error)
          // 如果获取用户信息失败，使用默认信息
          const userData = resp?.data?.user || resp?.user || {}
          const userInfo = {
            nickname: userData.nickname || userData.name || this.username || '用户',
            username: userData.username || userData.account || this.username,
            phone: userData.phone || userData.mobile || '',
            balance: userData.balance || userData.amount || 0
          }
          
          console.log('=== 使用默认用户信息 ===')
          console.log('默认用户信息:', userInfo)
          console.log('========================')
          
          this.$store.commit('SET_INFO', userInfo)
          // 兜底：从响应的 user 或 token 中尽力写入 userId 缓存
          try {
            const uid = userData.userId || userData.id || userData.uid || userData.uuid
            if (uid) {
              localStorage.setItem('userId', String(uid))
            } else {
              const tk = this.$store.getters.token || localStorage.getItem('token')
              const parts = (tk || '').split('.')
              if (parts.length === 3) {
                const payload = JSON.parse(atob(parts[1]))
                const tid = payload && (payload.userId || payload.uid || payload.sub)
                if (tid) localStorage.setItem('userId', String(tid))
              }
            }
          } catch (e2) { /* ignore */ }
        }
        
        this.$router.replace('/home')
      } catch (e) {
        console.error('登录失败:', e)
        alert((e.response?.data?.message) || '登录失败，请检查账号或密码')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.logo {
  width: 100px;
  height: 100px;
  background: #3572e6;
  border-radius: 20px;
  margin: 48px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(53, 114, 230, 0.3);
}

.logo-text {
  color: #fff;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  letter-spacing: 3px;
}

.title {
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  margin-top: 24px;
  color: #222;
}

.subtitle {
  text-align: center;
  color: #888;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 32px;
}

.tab-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  border-bottom: 1.5px solid #eaeaea;
}

.tab {
  flex: 1;
  text-align: center;
  font-size: 18px;
  color: #b0b0b0;
  padding: 10px 0 8px 0;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s;
  position: relative;
}

.tab.active {
  color: #3572e6;
  font-weight: 600;
}

.tab.active::after {
  content: '';
  display: block;
  position: absolute;
  left: 30%;
  right: 30%;
  bottom: -2px;
  height: 2.5px;
  background: #3572e6;
  border-radius: 2px;
}

.form {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.input-group {
  display: flex;
  align-items: center;
  background: #f7f8fa;
  border-radius: 12px;
  padding: 0 12px;
  height: 48px;
  border: 1.5px solid #f0f0f0;
}

.input-prefix {
  color: #b0b0b0;
  font-size: 16px;
  margin-right: 4px;
  flex-shrink: 0;
}

.input {
  border: none;
  background: transparent;
  outline: none;
  font-size: 16px;
  flex: 1;
  height: 44px;
  color: #222;
}

.input::-webkit-input-placeholder {
  color: #b0b0b0;
}

.input:disabled {
  color: #b0b0b0;
}

.get-captcha-btn {
  background: #f7f8fa;
  color: #3572e6;
  border: none;
  font-size: 15px;
  padding: 0 12px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  margin-left: 8px;
  transition: background 0.2s;
}

.get-captcha-btn:active {
  background: #e6f0ff;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
  margin-bottom: 4px;
}

.checkbox {
  accent-color: #3572e6;
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.remember-label {
  color: #222;
  font-size: 15px;
  user-select: none;
}

.forget {
  color: #3572e6;
  font-size: 15px;
  cursor: pointer;
  user-select: none;
}

.contact-service {
  color: #3572e6;
  font-size: 15px;
  cursor: pointer;
  user-select: none;
  margin-left: 12px;
}

.login-btn {
  width: 100%;
  height: 48px;
  background: #3572e6;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  border: none;
  border-radius: 24px;
  margin: 18px 0 0 0;
  box-shadow: 0 2px 8px #3572e633;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
}

.login-btn:active {
  background: #2456b6;
  transform: scale(0.98);
}

.wechat-login-btn {
  width: 100%;
  height: 48px;
  background: #07c160;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  border: none;
  border-radius: 24px;
  margin: 12px 0 0 0;
  box-shadow: 0 2px 8px rgba(7, 193, 96, 0.3);
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.wechat-login-btn:active {
  background: #06ad56;
  transform: scale(0.98);
}

.wechat-icon {
  font-size: 20px;
}

.password-toggle-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
}

.password-toggle-btn:hover {
  opacity: 0.7;
}

.eye-icon {
  font-size: 18px;
  user-select: none;
}
</style>
